export * from './core-qr-code.component';